var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 18.5C4.02823 18.5 0 14.4718 0 9.5C0 4.52823 4.02823 0.5 9 0.5C13.9718 0.5 18 4.52823 18 9.5C18 14.4718 13.9718 18.5 9 18.5ZM10.0488 13.2887L7.30887 10.6613H13.9355C14.4181 10.6613 14.8065 10.273 14.8065 9.79032V9.20968C14.8065 8.72702 14.4181 8.33871 13.9355 8.33871H7.30887L10.0488 5.71129C10.4008 5.37379 10.4081 4.81129 10.0633 4.46653L9.66411 4.07097C9.32298 3.72984 8.77137 3.72984 8.43387 4.07097L3.61814 8.88306C3.27702 9.22419 3.27702 9.77581 3.61814 10.1133L8.43387 14.929C8.775 15.2702 9.32661 15.2702 9.66411 14.929L10.0633 14.5335C10.4081 14.1887 10.4008 13.6262 10.0488 13.2887Z",
    fill: "#3C7363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorNew);
export default __webpack_public_path__ + "static/media/Vector_new.11af097be26ce5b02b96dd0b92162291.svg";
export { ForwardRef as ReactComponent };